import * as types from './actionTypes';

export function onShowSidebarIzquierda(showSidebarIzquierda) {
  return {type: types.ON_SHOW_SIDEBAR_IZQUIERDA, datos:showSidebarIzquierda};
}


export function sidebarIzquierda(sidebarIzquierda) {
  return {type: types.ON_SIDEBAR_IZQUIERDA, datos:sidebarIzquierda};
}
